import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Animator } from '../providers.module/_animator';

/**
 * Ladeanimations-Interceptor.
 *
 * Zeigt nach einem Delay von 800 ms (konfiguriert in {@link Animator}) eine
 * Ladeanimation an, solange mindestens ein REST-Request offen ist.
 * Die Animation wird automatisch ausgeblendet, sobald alle Requests
 * abgeschlossen sind (Erfolg oder Fehler).
 */
@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        Animator.addRequest();

        return next.handle(req).pipe(
            finalize(() => Animator.resolveRequest())
        );
    }

}

